import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";

// import NDAaggrementPrimary from "../../Aggrement & NDAs/ndaAggrementPrimary";
import AgreementsPage from "./Nda";
import ApplicationForm from "./Halal certifcation Application Form";
import PrimaryPayment from "./paymentProcess/primaryPayment";



import { useNavigate } from "react-router-dom";

import CustomClientPortalProfile from "../../../Global_Component/CustomClientPortalProfile";


// Main Tab Component
export default function CertificatePrimary() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

   const limit=3;
    const navigate = useNavigate();
  
    function MoveToNextTab() {
      if (activeTab >= limit) {
        navigate("/dashboard/home");
      } else {
        setActiveTab(activeTab + 1);
      }
    }
  
    function MoveToPreviousTab() {
      if (activeTab <= 0) {
        console.log("Reach the Limit of Below");
      } else {
        setActiveTab(activeTab - 1);
      }
    }
  

  return (
    <Box  sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        width: "100%",
        maxHeight: "100%",
        padding:2,
        height:"100%",
       
        overflowY: "auto",
        textAlign:"left",
        bgcolor:"#EDF2F9",
        // Custom scrollbar styles
        "&::-webkit-scrollbar": {
          width: "6px", // Width of the scrollbar
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1", // Track color
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888", // Thumb color
          borderRadius: "10px", // Optional rounded edges for the thumb
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555", // Thumb color on hover
        },
      }}>

        <CustomClientPortalProfile />
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"

        sx={{
          borderBottom: 0,
          bgcolor:"white",
          width:"100%",
          borderColor: "divider",
          "& .MuiTab-root": { textTransform: "none", fontWeight: "500" },
        }}
      >
        <Tab label="Agreements & NDAs" />
        <Tab label="Hala Certification Application Form" />
        <Tab label="Payment Receipt" />
       
      
        
      </Tabs>

      {/* Content Area */}
      <Box mt={2} sx={{bgcolor:"white",width:"100%",height:"auto",my:0}}>
        {activeTab === 0 && <AgreementsPage />}
        {activeTab === 1 && <ApplicationForm />}
        {activeTab === 2 && <PrimaryPayment />}
       
       
      </Box>
    </Box>
  );
}
